import { render, staticRenderFns } from "./CompanyAttributeCalculator.vue?vue&type=template&id=e52d707e&scoped=true"
import script from "./CompanyAttributeCalculator.vue?vue&type=script&lang=js"
export * from "./CompanyAttributeCalculator.vue?vue&type=script&lang=js"
import style0 from "./CompanyAttributeCalculator.vue?vue&type=style&index=0&id=e52d707e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52d707e",
  null
  
)

export default component.exports